// extracted by mini-css-extract-plugin
export default {"root":"NotFound_root__ubvMv"};